<ng-container style="height: 100%; width: 100%;">
    <ngb-carousel
      style="height: 100%; width: 100%;"
      #carousel
      [interval]="4000"
      [showNavigationIndicators]="false"
      [showNavigationArrows]="false"
      [wrap]="true"
      [pauseOnHover]="false">
      <ng-template ngbSlide *ngFor="let img of imagesarray">
        <div style="height: 100%; width: 100%; display: flex; flex-direction: row;">
          <img style="height: 100%; width: 100%;" [src]="img" alt="">
        </div>
      </ng-template>
    </ngb-carousel>
  </ng-container>